/**
 * @author NikolaV
 */
import * as React from 'react';
import { MapScale } from '@openlayers/MapScale';
import { MapRotate } from '@openlayers/MapRotate';
import OlMap from 'ol/Map';


export class MapScaleRotate extends React.Component<{
    mapInstance?: OlMap
}, {}> {
    mapScale: MapScale;

    render() {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end'
            }}>
                <MapRotate mapInstance={this.props.mapInstance}/>
                <div style={{ marginTop: 10 }}>
                    <MapScale mapInstance={this.props.mapInstance} ref={el => this.mapScale = el}/>
                </div>
            </div>
        );
    }

    getScale = () => this.mapScale.getScale()
}
